module.exports = __webpack_public_path__ + "img/company_logo.c7ba87d4.svg";